import React, { Component } from 'react';

// This is the resource used to create this page
// https://www.freecodecamp.org/news/reactjs-implement-drag-and-drop-feature-without-using-external-libraries-ad8994429f1a/
// Images are from: https://animalcrossing.fandom.com/wiki/Flower

class Flower extends Component { // array to hold the initial available options 
    state = {
        flowers: [
            {name:"Yellow Cosmos",category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2a/NH-yellow_cosmos-icon.png/revision/latest?cb=20200414010649"},
            {name:"White Cosmos", category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/4/45/NH-white_cosmos-icon.png/revision/latest?cb=20200414010606"},
            {name:"Red Cosmos", category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7a/NH-red_cosmos-icon.png/revision/latest?cb=20200414010628"},

          ]
        }

    onDragStart = (ev, id) => { // transferring the name of the flower to the onDrop function
        ev.dataTransfer.setData("id", id);
    }

    onDragOver = (ev) => {
        ev.preventDefault();
    }

    onDrop = (ev, cat) => { // create new flower with updated category
       let id = ev.dataTransfer.getData("id");

       let flowers = this.state.flowers.filter((flower) => {
           if (flower.name === id) {
               flower.category = cat;
           }
           return flower;
       });

       this.setState({
           ...this.state,
           flowers
       });

    }

	reset = () => { // setting the state of the available options back to original state 
        this.setState ({
            flowers: [
                {name:"Yellow Cosmos",category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2a/NH-yellow_cosmos-icon.png/revision/latest?cb=20200414010649"},
                {name:"White Cosmos", category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/4/45/NH-white_cosmos-icon.png/revision/latest?cb=20200414010606"},
                {name:"Red Cosmos", category:"available", bgimage: "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7a/NH-red_cosmos-icon.png/revision/latest?cb=20200414010628"}
            ]
        })
    }

    render() {
        var flowersArray = {
            available: [],
            target: []
        }

        var img = "";
        var showHide = "hidden";

        this.state.flowers.forEach ((t) => { // creating category for each flower 
            flowersArray[t.category].push(
                <div key={t.name} 
                    onDragStart = {(e) => this.onDragStart(e, t.name)}
                    draggable
                    className="draggable"
                >
                    <img alt={t.name} src={t.bgimage}></img>
                </div>
            );
        });

        if (flowersArray.target.length === 1) { // deciding which flower to display as the result depending on which flower the user dragged 
            if (flowersArray.target[0].key === "Red Cosmos") {
                img = "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7f/NH-black_cosmos-icon.png/revision/latest?cb=20200414010804";
            } else if (flowersArray.target[0].key === "White Cosmos") {
                img = "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e4/NH-pink_cosmos-icon.png/revision/latest?cb=20200414010708";
            } else {
                img = "https://vignette.wikia.nocookie.net/animalcrossing/images/f/f9/NH-orange_cosmos-icon.png/revision/latest?cb=20200414010731";
            }
            showHide = "show";
        }

        if (flowersArray.target.length > 1) { // if user drags more than one flower to the "flower 2" box, this message alerts the user 
            window.alert("Press the restart button to try another combination.");
        }

        // displaying the introduction, reset button, and four sections (available options, base flower 1, flower 2 section for the user to drag 
        // and drop the flower, resulting flower section)
        return (
            <div className="breeding">
                <h3>In New Horizons, players can create selective flowers through cross-breeding. Give it a try with the cosmos flowers by dragging and 
                    dropping a flower from the available section to Flower 2!
                </h3>
                <button aria-label="Reset"onClick={e => this.reset()}>Reset</button>
                <div className="container-drag">
                    <div className="available" 
                        onDragOver={(e)=>this.onDragOver(e)}
                        onDrop={(e)=>{this.onDrop(e, "available")}}>
                        <span className="task-header">Available Cosmos Colors</span>
                        {flowersArray.available}
                    </div>
                    <br></br>
                    <div className="base"> 
                        <span className="task-header">Flower 1</span> 
                        <img alt="Red Cosmos Flower" src="https://vignette.wikia.nocookie.net/animalcrossing/images/7/7a/NH-red_cosmos-icon.png/revision/latest?cb=20200414010628" />
                    </div>
                    <br></br>
                    <h3>X</h3>
                    <div className="droppable" 
                        onDragOver={(e)=>this.onDragOver(e)}
                        onDrop={(e)=>this.onDrop(e, "target")}>
                        <span className="task-header">Flower 2</span>
                        {flowersArray.target}
                    </div>
                    <br></br>
                    <h3>=</h3>
                    <div className="result">
                        <span className="task-header">Result</span>
                        <img alt="Resulting Flower" className={showHide} src={img}></img>
                    </div>
                </div>
            </div>
        );
    }
}

export default Flower;

export {Flower};